export class ExternalId {
  group: string;
  id: string;

  constructor(id?: any) {
    id = id || {};
    this.group = id.group || null;
    this.id = id.id || null;
  }
}
